import { styled } from 'styled-components';

import { LegacyButton } from 'components/LegacyButton/LegacyButton';
import { colors, mediaRetina, transition } from 'theme/theme';

export const AddButton = styled(LegacyButton)`
  position: relative;

  & > * {
    position: relative;
    border: 1px dashed ${colors.elementGrey};
    color: ${colors.brandBlue};
    border-radius: 4px;
    transition: all ${transition};
    ${mediaRetina} {
      border-width: 1.5px;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    opacity: 0;
    background: ${colors.inputGrey};
    transition: all ${transition};
  }

  &:hover,
  &:focus {
    & > * {
      border-color: ${colors.hoverBlue};
      color: ${colors.hoverBlue};
    }

    &::before {
      opacity: 1;
    }
  }
`;
